import { ExamEventScoreReportSection } from '@exam-center/exam-event-score-report';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { PermissionGuard } from '@shared/permissions';

export default function ExamEventScoreReportPage() {
  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.RESULTS.VIEW}>
      <ExamEventScoreReportSection />
    </PermissionGuard>
  );
}
